(function () {
    "use strict";

    angular.module("app").directive("fodbzNationalities", NationalitiesDirective);

    NationalitiesDirective.$inject = ["$compile", "$rootScope",];

    function NationalitiesDirective($compile, $rootScope) {
        const template = `<div>
                            <div class="row space-below">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <button class="btn btn-primary pull-left"
                                            ng-click="Add()">
                                        <i class="fa-solid fa-circle-plus"></i> {{'Person_AddNationality' | habilTranslation}}
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                    <fodbz-helped-label-required
                                            fodbz-field="MyNationality_Label"
                                            fodbz-resource="{{'Person_Nationality' | habilTranslation}}"
                                            fodbz-info="{{'Person_Info_Nationality' | habilTranslation}}">
                                    </fodbz-helped-label-required>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <fodbz-label-required
                                            fodbz-field="MyNationality_DateFrom_Label"
                                            fodbz-resource="{{'Person_Nationality_From' | habilTranslation}}">
                                    </fodbz-label-required>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <fodbz-label-required
                                            fodbz-field="MyNationality_DateTo_Label"
                                            fodbz-resource="{{'Person_Nationality_To' | habilTranslation}}">
                                    </fodbz-label-required>
                                </div>
                            </div>
                            <div class="row" ng-repeat="Nationality in fodbzModel">
                                <div class="row space-below" ng-if="Nationality.FromRR">
                                    <div class="col-lg-3 col-md-3 col-sm-8 col-xs-12">
                                        <i class="fa-solid fa-fw fa-id-card"></i> {{Nationality.NationalityCode | codeValue:codeNationalities}}
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                        {{Nationality.DateFrom | date:'dd/MM/yyyy'}}
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                        <span ng-if="Nationality.DateTo">{{Nationality.DateTo | date:'dd/MM/yyyy'}}</span>
                                        <span ng-if="!Nationality.DateTo" i18n="Present_Date"></span>
                                    </div>
                                </div>
                                <div class="row space-below" ng-if="!Nationality.FromRR">
                                    <ng-form name="NationalityForm">
                                        <div class="col-lg-3 col-md-3 col-sm-8 col-xs-12">
                                            <fodbz-dropdown-required 
                                                    fodbz-model="Nationality.NationalityCode"
                                                    fodbz-field-const="MyNationality{{$index}}"
                                                    organisation-types="codeNationalities"
                                                    fodbz-init="{{fodbzInit}}">
                                            </fodbz-dropdown-required>
                                            <fodbz-validation fodbz-errors="NationalityForm['MyNationality' + $index].$error" fodbz-role="Alert" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                            <fodbz-datepicker
                                                    fodbz-field-const="MyNationality_DateFrom{{$index}}"
                                                    fodbz-object="Nationality.DateFrom"
                                                    fodbz-language-code="{{fodbzLanguageCode}}"
                                                    fodbz-place-holder="{{fodbzPlaceHolder}}">
                                            </fodbz-datepicker>
                                            <fodbz-validation fodbz-errors="NationalityForm['MyNationality_DateFrom' + $index].$error" fodbz-role="Alert" />
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12" ng-if="!Nationality.DateToNeeded">
                                            <fodbz-datepicker
                                                    fodbz-field-const="MyNationality_DateTo{{$index}}"
                                                    fodbz-object="Nationality.DateTo"
                                                    fodbz-language-code="{{fodbzLanguageCode}}"
                                                    fodbz-place-holder="{{fodbzPlaceHolder}}">
                                            </fodbz-datepicker>
                                            <fodbz-validation fodbz-errors="NationalityForm['MyNationality_DateTo' + $index].$error" fodbz-role="Alert" />
                                        </div>
									    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox"
                                                       class="custom-control-input custom-check"
                                                       ng-attr-id="{{fodbzFieldConst}}_Nationality_DateToNeeded-{{$index}}"
                                                       ng-model="Nationality.DateToNeeded" 
                                                       ng-change="Nationality.DateTo = (Nationality.DateToNeeded) ? undefined : Nationality.DateTo" />
                                                <label class="custom-control-label" for="{{fodbzFieldConst}}_Nationality_DateToNeeded-{{$index}}" style="padding-left: 1em" i18n="Present_Date"></label>
                                            </div>
                                        </div>
                                        <div class="btn-group">
                                            <button class="btn btn-danger pull-right"
                                                    title="{{'Person_Nationality_Remove' | habilTranslation}}"
                                                    ng-click="Remove(Nationality)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </ng-form>
                                </div>
                            </div>
                        </div>`;
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: "=",
                fodbzFieldConst: "@",
                fodbzErrorItem: "=",
                fodbzLanguageCode: "@",
                fodbzPlaceHolder: "@",
                fodbzInit: "@"
            },
            controller: ["$scope", function ($scope) {
                $scope.Placing = $scope.fodbzFieldConst;
            }],
            link: function (scope, elem) {
                scope.codeNationalities = $rootScope.codeNationalities;

                scope.Add = function () {
                    scope.fodbzModel.push({ PublicId: $rootScope.guid.new() });
                };

                scope.Remove = function (item) {
                    const index = scope.fodbzModel.indexOf(item);
                    scope.fodbzModel.splice(index, 1);
                };

                const linkFn = $compile(template.replace(/MyNationality/g, scope.Placing));
                const content = linkFn(scope);
                elem.append(content);
            }
        };
    }
})();